const bcActionFailedModalTypes = {
    CREATE_CONTACT: 'CREATE_CONTACT',
    EDIT_CONTACT: 'EDIT_CONTACT',
    CREATE_ACCOUNT_PARTY: 'CREATE_ACCOUNT_PARTY',
    EDIT_ACCOUNT_PARTY: 'EDIT_ACCOUNT_PARTY',
    SEND_MESSAGE: 'SEND_MESSAGE',
};

export default bcActionFailedModalTypes;
